import React, { useCallback } from "react";
import { ButtonBase, CircularProgress, MenuItem, Typography } from "@mui/material";
import { ArrowBackIos, Delete as DeleteIcon } from "@mui/icons-material";
import styles from "./Style.module.css";
import useRoleDetailHook from "./RoleDetail.hook";
import { makeStyles, useTheme } from "@mui/styles";
import RoleTableComponent from "../component/RoleTable.componnet";
import CustomSelectField from "../../../components/FormFields/SelectField/SelectField.component";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import { CreateActionComponent, CreateHeadaerComponent, HeaderTitleComponet } from "../../../components/CustomListHeader/CustomListHeader";
import RoleAssociatedUsers from "./AssociatedUsers/AssociatedUsers";
import StatusPill from "../../../components/Status/StatusPill.component";

const useStyles = makeStyles((theme) => ({
  iconBtnError: {
    color: theme.palette.error.dark,
  },
  deleteBtn: {
    color: "red",
  },
}));

const RoleDetail = () => {
  const {
    form,
    errorData,
    permisionChangeHandler,
    detailId,
    setPermissions,
    permission,
    listData,
  } = useRoleDetailHook();
  const classes = useStyles();
  const theme = useTheme();


  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    } else {
      return <StatusPill status={"Active"} color={"active"} />;
    }
  }, []);

  return (
    <>
      <CreateHeadaerComponent title={"Role Detail"} />
      <div className={styles.container}>
        <ShadowBox width={"100%"}>
          <div className={styles.headerContainer}>
            <HeaderTitleComponet headerTitle={"Role Details"} />

            <div>{renderStatus(form?.status)}</div>
          </div>

          <div className={"formFlex"}>
            <div className={"formGroup"}>
              <CustomTextField
                isError={errorData?.name}
                disabled={detailId ? true : false}
                errorText={errorData?.name}
                label={
                  <>
                    Role Name
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={form?.name}
              />
            </div>
          </div>
          <div className={"formFlex"}>
            <div className={"formGroup"}>
              <CustomTextField
                disabled={detailId ? true : false}
                label={
                  <>
                    Role Code
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={form?.code}
              >
              </CustomTextField>
            </div>
            {/* <div className={"formGroup"}>
              <CustomSelectField
                isError={errorData?.applies}
                errorText={errorData?.applies}
                disabled={detailId ? true : false}
                label={
                  <>
                    Applies To
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={form?.applies}
              >
                {listData?.APPLIES?.map((item) => {
                  return (
                    <MenuItem
                      key={item?.id}
                      value={item?.id}
                    >{`${capitalizeFirstLetter(item?.name)}`}</MenuItem>
                  );
                })}
              </CustomSelectField>
            </div> */}
          </div>
          <div className={"formFlex"}>
            <div className={"formGroup"}>
              <CustomTextField
                isError={errorData?.description}
                errorText={errorData?.description}
                disabled={detailId ? true : false}
                multiline
                rows="3"
                label="Description"
                value={form?.description}
              />
            </div>
          </div>
        </ShadowBox>
        <div>
          <RoleTableComponent
            disabled={detailId ? true : false}
            permissions={permission}
            permisionChangeHandler={permisionChangeHandler}
            setPermissions={setPermissions}
          />
        </div>

        <div>
          <RoleAssociatedUsers detailId={detailId} />
        </div>

      </div>

    </>
  );
};

export default RoleDetail;
